module.exports = __webpack_public_path__ + "static/recruit__team__leader-fc973c52fb597af0a018f73851d7a8ee.jpg";